import * as d3 from 'd3';
import {processDateSeriesCsvData, scaled} from '../utils';
import {DEFAULT_CHART_WIDTH, VACCINATION_CHARTS_LEFT_PADDING, VACCINATION_CHARTS_RIGHT_PADDING} from '../constants';
import lineChart from '../utils/line-chart';

export default function() {
  // required parameters
  let data;

  // constants
  const height = scaled(400, width);
  const padding = [20, VACCINATION_CHARTS_RIGHT_PADDING, 30, VACCINATION_CHARTS_LEFT_PADDING];

  const chart = function(selection) {
    selection.each(function() {
      const container = d3.select(this);

      container.attr('id', 'ireland-vaccinations')
        .attr('class', 'chart');

      const [lines, dates] = processDateSeriesCsvData(data, ['type']);

      container.append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin meet')
        .datum({lines, dates})
        .call(lineChart()
          .width(width)
          .height(height)
          .padding(padding)
          .isFilled(true)
          .classNameAccessor(d => {
            switch (d.type) {
              case 'peopleVaccinated': return 'dose-one';
              case 'peopleFullyVaccinated': return 'dose-two';
            }
          })
          .hasLabels(true)
          .labelAccessor(d => {
            switch (d.type) {
              case 'peopleVaccinated': return 'At least 1 dose';
              case 'peopleFullyVaccinated': return 'Fully vaccinated';
            }
          })
          .labelOffsetYAccessor(d => {
            switch (d.type) {
              case 'peopleVaccinated': return 10;
              case 'peopleFullyVaccinated': return 0;
            }
          })
        );
    });
  };

  chart.data = function(_) {
    if (!arguments.length) return data;
    data = _;
    return chart;
  };

  return chart;
}
